import React, { useState, useRef, useEffect } from "react";
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem,
    TextField,
    Box, IconButton, Typography
} from "@mui/material";
import { toast } from 'react-toastify';
const SalaryActivityComponent = ({activities, SetBalanceUsed, setFormData, view}) => {
    const [activityRecords, setActivityRecords] = useState(
        activities
    );
    const handleActivityBalance = (index, event) => {
        let value = event.target.value;
        const totalBalanceUsedExcludingIndex = (excludeIndex) => {
            return activityRecords.reduce((sum, item, i) => {
                if (i === excludeIndex) return sum; // skip this index
                return sum + (Number(item?.balanceUsed) || 0);
            }, 0);
        };
        // balanceUsed += value;
        
        setActivityRecords(prev =>
            prev.map((item, i) => {
            if (i !== index) return item; // leave other items as is

            // Rule 1: Negative value → ignore update
            if (value < 0) {
                toast.error("Value cannot be negative", {
                    position: toast.POSITION.TOP_CENTER
                });
                return item; // keep old value
            }

            // Rule 2: Greater than budget → ignore update + show error
            if (value > (item.budget || 0)) {
                toast.error(`Value cannot exceed budget (${item.budget})`, {
                    position: toast.POSITION.TOP_CENTER
                });
                return item; // keep old value
            }

            // Rule 3: Valid value → update
            SetBalanceUsed(Number(totalBalanceUsedExcludingIndex(index) + Number(value)));
            
            return { ...item, balanceUsed: value };
            })
        );
    }

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            activities: activityRecords,
        }));
    }, [activityRecords])

    return (
        <div>
            {
                activityRecords.map((activity, index) => (
                    <div className="row p-2" key={index}>
                        <div className="col-4 d-flex flex-column gap-1">
                            <FormControl fullWidth>
                                <TextField 
                                id="activity"
                                label="Activity" 
                                variant="outlined" 
                                type="text"
                                value={activity.activity}
                                required
                                />
                            </FormControl>
                        </div>
                        <div className="col-4 d-flex flex-column gap-1">
                            <FormControl fullWidth>
                                <TextField 
                                id="subactivity"
                                label="Sub Activity" 
                                variant="outlined" 
                                type="text"
                                value={activity.subactivity}
                                required
                                />
                            </FormControl>
                        </div>
                        <div className="col-2 d-flex flex-column gap-1">
                            <FormControl fullWidth>
                                <TextField 
                                id="activity_balance"
                                label="Balance" 
                                variant="outlined" 
                                type="text"
                                value={activity.budget}
                                required
                                />
                            </FormControl>
                        </div>
                        <div className="col-2 d-flex flex-column gap-1">
                            <FormControl fullWidth>
                                <TextField 
                                id="activity_amount"
                                label="Amount" 
                                variant="outlined" 
                                type="text"
                                onChange={e => handleActivityBalance(index, e)}
                                value={activity?.balanceUsed || 0}
                                disabled={view}
                                required
                                />
                            </FormControl>
                        </div>
                    </div>
                    )
                )
            }
        </div>
    )

}

export default SalaryActivityComponent;